/**
 * @fileoverview
 * Audit Constants
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

export const AUDIT_MODULE = {
  CASH: 'CASH',
  VALUATION_TOOL: 'VALUATION_TOOL',
  GOLD_VERIFICATION: 'GOLD_VERIFICATION',
  PACKET_INVENTORY: 'PACKET_INVENTORY',
  ROUTINE_CHECKING: 'ROUTINE_CHECKING',
  LOAN_PROCESS_CHECKING: 'LOAN_PROCESS_CHECKING',
  TARE_WEIGHT: 'TARE_WEIGHT',
  REGISTER_STATUTORY: 'REGISTER_STATUTORY',
  KYC_DISBURSEMENT: 'KYC_DISBURSEMENT',
  RELEASE: 'RELEASE',
  SECURITY: 'SECURITY',
  ASSET: 'ASSET',
  KEY: 'KEY',
  BRANCH_AUDIT: 'BRANCH_AUDIT',
} as const;


/** Label/value pairs for audit module heading dropdown (e.g. dynamic form creation). Value matches AUDIT_MODULE_HEADING. */
export const AUDIT_MODULE_HEADING_OPTIONS: readonly { label: string; value: string }[] = [
  { label: 'Cash Audit', value: 'CASH_AUDIT' },
  { label: 'Gold Audit (Valuation Tool)', value: 'GOLD_AUDIT_VALUATION_TOOL' },
  { label: 'Gold Audit (Verification)', value: 'GOLD_AUDIT_VERIFICATION' },
  { label: 'Packet Inventory Audit', value: 'PACKET_INVENTORY_AUDIT' },
  { label: 'Surveillance Audit (Loan Process Checking)', value: 'SURVEILLANCE_AUDIT_LOAN_PROCESS_CHECKING' },
  { label: 'Tare Weight Audit', value: 'TARE_WEIGHT_AUDIT' },
  { label: 'Registers and Statutory Audit', value: 'REGISTER_STATUTORY_AUDIT' },
  { label: 'Online Audit (KYC & Disbursement)', value: 'ONLINE_AUDIT_KYC_AND_DISBURSEMENT' },
  { label: 'Online Audit (Release Audit)', value: 'ONLINE_AUDIT_RELEASE' },
  { label: 'Asset Entry', value: 'ASSET_ENTRY' },
  { label: 'Asset Audit', value: 'ASSET_AUDIT' },
  // { label: 'Vault Key Entry', value: 'VAULT_KEY_ENTRY' },
  // { label: 'Key Movement Sender', value: 'KEY_MOVEMENT_SENDER' },
  // { label: 'Key Movement Receiver', value: 'KEY_MOVEMENT_RECEIVER' },
  { label: 'Key Audit', value: 'KEY_AUDIT' },
  { label: 'Security Audit', value: 'SECURITY_AUDIT' },
];

/** Map backend audit.module (AuditModule enum) to AUDIT_MODULE_HEADING_OPTIONS value for label lookup. */
const AUDIT_MODULE_TO_HEADING_VALUE: Record<string, string> = {
  CASH: 'CASH_AUDIT',
  TARE_WEIGHT: 'TARE_WEIGHT_AUDIT',
  GOLD_VERIFICATION: 'GOLD_AUDIT_VERIFICATION',
  VALUATION_TOOL: 'GOLD_AUDIT_VALUATION_TOOL',
  PACKET_INVENTORY: 'PACKET_INVENTORY_AUDIT',
  REGISTER_STATUTORY: 'REGISTER_STATUTORY_AUDIT',
  LOAN_PROCESS_CHECKING: 'SURVEILLANCE_AUDIT_LOAN_PROCESS_CHECKING',
  ROUTINE_CHECKING: 'ROUTINE_CHECKING_AUDIT',
  KYC_DISBURSEMENT: 'ONLINE_AUDIT_KYC_AND_DISBURSEMENT',
  RELEASE: 'ONLINE_AUDIT_RELEASE',
  SECURITY: 'SECURITY_AUDIT',
  ASSET: 'ASSET_AUDIT',
  KEY: 'KEY_AUDIT',
  BRANCH_AUDIT: 'BRANCH_AUDIT',
};

/** Resolve display label for audit module using AUDIT_MODULE_HEADING_OPTIONS. */
export function getAuditModuleLabel(moduleCode: string | null | undefined): string {
  if (moduleCode == null || moduleCode === '') return '';
  const headingValue = AUDIT_MODULE_TO_HEADING_VALUE[moduleCode] ?? moduleCode;
  const option = AUDIT_MODULE_HEADING_OPTIONS.find((o) => o.value === headingValue);
  return option?.label ?? moduleCode;
}

export enum OtpContextType {
  ASSET_ENTRY = 'asset',
  /** Vault Key Entry acknowledgement OTP (Send OTP – use this, not vault_key_and_entry). */
  VAULT_KEY = 'vault_key',
  VAULT_KEY_AND_ENTRY = 'vault_key_and_entry',
  KEY_MOVEMENT_SENDER = 'key_movement_sender',
  KEY_MOVEMENT_RECIEVER = 'key_movement_reciever',
  SECURITY_AUDIT = 'security_audit',
  ASSET_AUDIT = 'asset_audit',
  KEY_AUDIT = 'key_audit',
  BRANCH_AUDIT = 'branch_audit',
  GOLD_VERIFICATION_AUDIT = 'gold_verification_audit',
  /** Cash audit acknowledgement – global /otp/request, /otp/verify */
  CASH_AUDIT = 'cash_audit',
  /** Tare weight audit acknowledgement – global OTP */
  TARE_WEIGHT_AUDIT = 'tare_weight_audit',
  /** Valuation tool audit acknowledgement – global OTP */
  VALUATION_TOOL_AUDIT = 'valuation_tool_audit',
  /** Packet inventory acknowledgement – global OTP */
  PACKET_INVENTORY = 'packet_inventory_audit',
  /** Register & statutory acknowledgement – global OTP */
  REGISTER_STATUTORY = 'register_statutory_audit',
}
